import React from "react";
import { connect } from "react-redux";

import {
  objectToArray,
  convertHMToSecs,
  removeItem,
  formatSecsToHrRange
} from "utils";
import { ReactComponent as EditScheduleIcon } from "assets/images/app_svg/backup/edit_schedule.svg";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { TOOLTIPS } from "consts";
import Tooltip from "App/common/ui/Tooltip";

import ClickAwayListener from "@material-ui/core/ClickAwayListener";

function BackupPlanScheduleCustom(props) {
  const [dropDown, setDropDown] = React.useState(false);

  const toggleDropDown = () => setDropDown(prevState => !prevState);
  const hours = [];
  const minutes = [];
  const weekDays = props.enums.WeekDays.props;

  React.useEffect(() => {
    if (props.planSettings.scheduleInfo.weekDays.length === 0) {
      props.setPlanSettings({
        ...props.planSettings,
        scheduleInfo: { ...props.planSettings.scheduleInfo, weekDays: [] }
      });
    }
  }, []);

  if (props.startTime) {
    for (let i = props.startTime.hour.min; i <= props.startTime.hour.max; i++) {
      hours.push(
        <li
          value={i}
          onClick={() => {
            toggleScheduleStartTime(i, "hr");
            setDropDown(false);
          }}
          key={i}
        >
          {formatSecsToHrRange(i * 3600)}{" "}
        </li>
      );
    }

    // for (
    //   let i = props.startTime.minute.min;
    //   i <= props.startTime.minute.max;
    //   i = i + props.startTime.minute.int
    // ) {
    //   minutes.push(
    //     <option key={i} value={i}>
    //       {i > 9 ? "" + i : "0" + i}
    //     </option>
    //   );
    // }
  }

  function updateDays(val) {
    let tempPlan = { ...props.planSettings };
    let weekDays = [...tempPlan.scheduleInfo.weekDays];
    if (props.planSettings.scheduleInfo.weekDays.includes(val.code)) {
      weekDays = removeItem(weekDays, weekDays.indexOf(val.code));
    } else {
      if (weekDays.length === 6) {
        weekDays = [];
        tempPlan.scheduleInfo.type = 1; // setting plan type to 'Daily' if all days were selected and user is now selecting one more day
      } else weekDays.push(val.code);
    }
    tempPlan.scheduleInfo.weekDays = weekDays.sort();
    props.setPlanSettings(tempPlan);
  }

  function toggleScheduleStartTime(val, type) {
    let tempPlan = { ...props.planSettings };
    let time = 0;
    if (type === "hr") {
      time = convertHMToSecs(
        val,
        Math.trunc((tempPlan.scheduleInfo.startTime % 3600) / 60)
      );
    } else {
      time = convertHMToSecs(
        Math.trunc(tempPlan.scheduleInfo.startTime / 3600),
        val
      );
    }
    tempPlan.scheduleInfo.startTime = time;
    props.setPlanSettings(tempPlan);
  }

  return (
    <React.Fragment>
      <div className="sche_backup_item custom random_schedule">
        <div className="custom_wrap flex_align">
          <p>Start Time:</p>
          <div className="hours_mins_wrap flex_align">
            <ClickAwayListener onClickAway={() => setDropDown(false)}>
              <div
                className="hours_wrap flex_align"
                style={{ marginRight: "10px" }}
              >
                <div className={`customSelect ${dropDown ? "active" : ""}`}>
                  <span className="hrsValue">
                    {formatSecsToHrRange(
                      props.planSettings.scheduleInfo.startTime
                    )}
                  </span>
                  <ul className="customDropdwn">{hours}</ul>
                </div>
                <button className="edit_ico" onClick={() => toggleDropDown()}>
                  <Tooltip {...{ title: "Edit", position: "top" }}>
                    <EditScheduleIcon />
                  </Tooltip>
                </button>
              </div>
            </ClickAwayListener>
            <Tooltip {...TOOLTIPS.backupSettings.schedule.editInfo}>
              <span className="slot_icon">
                <InformationIcon />
              </span>
            </Tooltip>
          </div>
        </div>

        <div className="days_wrap">
          {objectToArray(weekDays, { 1: "priority" }).map(val => (
            <div
              key={val.code}
              className={[
                "days_block",
                val.name + "__day",
                props.planSettings.scheduleInfo.weekDays.includes(val.code)
                  ? "active"
                  : null
              ].join(" ")}
              onClick={() => updateDays(val)}
            >
              {val.name}
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    startTime: state.backupSettings.scheduleInfo.startTime,
    enums: state.common.enums
  };
}

export default connect(mapStateToProps)(BackupPlanScheduleCustom);
